import { Settings, FileText, ShieldCheck, Building2, ArrowRight } from "lucide-react";

const PILLARS = [
  {
    Icon: Settings,
    title: "Market & Contract Configuration",
    desc: "Set up different ticket rules, SLA windows, required fields, and closeout steps for each customer or contract.",
  },
  {
    Icon: FileText,
    title: "Custom Forms & Audits",
    desc: "Build forms for damages, standbys, emergency tickets, QA inspections, and supervisor reviews without coding.",
  },
  {
    Icon: ShieldCheck,
    title: "Approval & Evidence Rules",
    desc: "Require specific photos, GPS confirmation, or supervisor sign-off before a ticket can close.",
  },
  {
    Icon: Building2,
    title: "Multi-Company Support",
    desc: "Run multiple companies, branches, or crews from one platform with complete data separation.",
  },
];

const FLOW = ["Import", "AI Review", "Assign", "Field", "Evidence", "QA", "Close", "Billing"];

export default function Customization() {
  return (
    <section data-testid="customization-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal mb-12">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Customization</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Built around your operation, not the other way around.
          </h2>
          <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
            Every market works differently. LocateOS adapts to your workflows — not the other way around.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {PILLARS.map(({ Icon, title, desc }, i) => (
            <div
              key={title}
              className="reveal group rounded-2xl glass p-7 hover:-translate-y-1 hover:border-white/20 transition-all"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="h-12 w-12 rounded-xl bg-[#FB923C]/15 border border-[#FB923C]/30 grid place-items-center shrink-0">
                  <Icon size={20} className="text-[#FDBA74]" />
                </div>
                <div>
                  <div className="font-display font-bold text-xl text-white">{title}</div>
                  <div className="mt-2 text-[#94A3B8] leading-relaxed">{desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Workflow builder */}
        <div className="mt-8 reveal rounded-2xl glass p-7">
          <div className="flex items-center justify-between mb-5">
            <div className="text-sm font-display font-bold text-white">Workflow Builder · Default Pipeline</div>
            <span className="status-pill bg-[#22C55E]/15 text-[#22C55E]">PUBLISHED</span>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {FLOW.map((step, i) => (
              <div key={step} className="flex items-center">
                <div
                  className={`px-4 py-2.5 rounded-xl text-sm font-medium border ${
                    i === 0 || i === FLOW.length - 1
                      ? "bg-[#F97316]/15 border-[#F97316]/40 text-[#F97316]"
                      : "bg-[#0a0a0a] border-white/10 text-white"
                  }`}
                >
                  {step}
                </div>
                {i < FLOW.length - 1 && <ArrowRight size={16} className="text-[#94A3B8] mx-2" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
